export default __webpack_public_path__ + "static/media/eye.b45fe15c.svg";